import { useMutation, useQuery } from "@tanstack/react-query";

import { AdminDetailDataAPI, LoginAPI, OauthLoginAPI } from "./auth.api";

export const authKeys = {
  all: ["auth"],
  adminDetail: () => [...authKeys.all, "admin-detail"],
};

export const useLoginMutation = () =>
  useMutation({
    mutationFn: LoginAPI,
  });

export const useOauthLoginMutation = () =>
  useMutation({
    mutationFn: OauthLoginAPI,
  });

export const useAdminDetailDataQuery = () =>
  useQuery({
    queryKey: authKeys.adminDetail(),
    queryFn: AdminDetailDataAPI,
  });
